/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */

/**
 * The four basic intents.
 */
export enum Intent {
    NONE = -1,
    PRIMARY,
    SUCCESS,
    WARNING,
    DANGER,
}
